import React from 'react';
import { StyleProp, StyleSheet, ViewStyle, useWindowDimensions } from 'react-native';
import { SharedValue } from 'react-native-reanimated';
import Svg, { Circle, Defs, FeGaussianBlur, Filter } from 'react-native-svg';

import { withOpacity } from '@/styles/styles';

import {
    TOP_GLOW_BLUR_VALUE,
    TOP_GLOW_CIRCLE_X,
    TOP_GLOW_CIRCLE_Y,
    TOP_GLOW_COLOR_OPACITY,
    TOP_GLOW_RADIUS,
} from '../utils/promotions-utils';

const styles = StyleSheet.create({
    canvas: {
        flex: 1,
        position: 'absolute',
        width: '100%',
        height: '100%',
    },
});

interface PromoDetailsTopGlowProps {
    color: string;
    headerHeight: SharedValue;
    style?: StyleProp<ViewStyle>;
    cx?: number;
    cy?: number;
    opacity?: number;
    radius?: number;
    blur?: number;
}

export const CircleTopGlow = ({
    color,
    headerHeight,
    style,
    cx,
    cy,
    opacity,
    radius,
    blur,
}: PromoDetailsTopGlowProps) => {
    const width = useWindowDimensions().width;
    return (
        <Svg style={[styles.canvas, style]} viewBox={`0 0 ${width} ${headerHeight.value}`}>
            <Defs>
                <Filter id="blurFilter" x="-50%" y="-50%" width="200%" height="200%">
                    <FeGaussianBlur in="SourceGraphic" stdDeviation={blur ?? `${TOP_GLOW_BLUR_VALUE}`} />
                </Filter>
            </Defs>
            <Circle
                cx={cx ?? `${TOP_GLOW_CIRCLE_X}`}
                cy={cy ?? `${TOP_GLOW_CIRCLE_Y}`}
                r={radius ?? `${TOP_GLOW_RADIUS}`}
                fill={withOpacity(color, opacity ?? TOP_GLOW_COLOR_OPACITY)}
                filter="url(#blurFilter)"
            />
        </Svg>
    );
};
